import {
  Button
} from "./chunk-7CU25RIV.mjs";

// src/social-buttons/social-button.tsx
import * as React from "react";
import { mergeStyles, systemForwardRef } from "@stepstone-genesis/system";

// src/social-buttons/styles.ts
var socialButtonStyles = {
  borderColor: "componentButtonSocialBorderColorDefault",
  color: "componentButtonSocialTextColorDefault",
  backgroundColor: "colorWhite",
  boxShadow: "boxShadowNone",
  paddingX: "spaceM",
  borderWidth: "1px",
  borderStyle: "solid",
  _hover: {
    borderColor: "componentButtonSocialBorderColorHover",
    backgroundColor: "colorWhite",
    color: "componentButtonSocialTextColorHover"
  },
  _active: {
    borderColor: "componentButtonSocialBorderColorActive",
    backgroundColor: "colorWhite",
    color: "componentButtonSocialTextColorActive",
    _hover: {
      backgroundColor: "colorWhite"
    }
  }
};
var styles = {
  socialButtonStyles
};

// src/social-buttons/social-button.tsx
var SocialButton = systemForwardRef(function SocialButton2({ children, sx, a11yLabel, iconBefore, ...props }, ref) {
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      ref,
      ...props,
      iconBefore,
      a11yLabel: a11yLabel != null ? a11yLabel : "Log in",
      sx: mergeStyles([styles.socialButtonStyles, sx])
    },
    children
  );
});

export {
  SocialButton
};
